import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MobileMenu from './MobileMenu';
import Toast from '@/components/common/Toast';

const PublicLayout: React.FC = () => {
  const { pathname } = useLocation();
  const showFooter = pathname === '/';
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-warm-bg">
      <Header
        showMenu
        onMenuClick={() => setIsMobileMenuOpen(true)}
      />

      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />

      <main className="flex-1">
        <Outlet />
      </main>
      {showFooter && <Footer />}
      <Toast />
    </div>
  );
};

export default PublicLayout;
